module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="background-region"></div>\n<div class="overlay-region"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/ui/viewer/ExperienceViewer.tpl
// module id = 2874
// module chunks = 0